import { Component, Vue, Prop, Emit, Mixins } from "vue-property-decorator";
import BASEComponentVue from '@/components/BASEComponentVue';
import BASEAPI from "@/util/BASEAPI";
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import SATextBox from './SATextBox.vue'
import SAFormLabel from './SAFormLabel.vue'
import SAButton from './SAButton.vue'
import SAText from './SAText.vue'

export interface SAMailAuthenticationResponse {
    user: BASEAPI.User;
    email: string;
    code: string;
}

@Component({
    components: {
        SATextBox, SAFormLabel, SAButton, SAText,
    },
})
export default class SAMailAuthentication extends Mixins(BASEComponentVue) {
    mode: number = 0
    error: string = "";
    kurukuru: boolean = false;

    email: string = "";
    code: string = "";
    element: HTMLElement = <HTMLElement>document.scrollingElement;

    @Emit("ok")
    public ok(val: SAMailAuthenticationResponse) {
        return val;
    };

    @Emit("back")
    public back() {
        return true;
    };

    @Prop({
        type: Object,
        default: (): BASEAPI.User => {
            return BASEAPI.user()
        },
    })
    public value!: BASEAPI.User;

    public async check1() {
        this.error = "";
        this.kurukuru = true;
        try {
            let res = await BASEAPI.MailController.sendMailUsingPOST(this.email, <any>(this.langEnglish ? "en" : undefined)).catch(AxiosErrorHandler);
            if (isAxiosError(res)) {
                this.error = "" + res.data;
            } else {
                this.mode = 1;
            }
        } catch (error) {
            this.error = "" + error;
        }
        this.element.scrollTop = 0;
        this.kurukuru = false;
    }

    public async check2() {
        this.error = "";
        this.kurukuru = true;
        try {
            let res = await BASEAPI.MailController.checkCodeUsingPOST(this.code).catch(AxiosErrorHandler);
            if (isAxiosError(res)) {
                this.error = "" + res.data;
            } else {
                let response: SAMailAuthenticationResponse = {
                    user: res.data,
                    email: this.email,
                    code: this.code
                }
                this.ok(response);
            }
        } catch (error) {
        }
        this.element.scrollTop = 0;
        this.kurukuru = false;
    }

    public backButton(value: number) {
        this.mode = value;
        this.element.scrollTop = 0;
        this.error = "";
    }
}
